(function(d,t,p){
	var e = d.createElement(t); e.charset = "utf-8"; e.src = ("https:" == d.location.protocol ?
  		"https://d1le22hyhj2ui8.cloudfront.net" : "http://js.testfreaks.com") + p;
	var s = d.getElementsByTagName(t)[0]; s.parentNode.insertBefore(e,s)
})(document,"script","/onpage/datavision.com/head.js")


// WEBPACK FOOTER //
// ./../src/assets/js/test-freaks.js